import { Modal, TextField, Typography } from "@mui/material";
import styled from "styled-components";
import { ASSETS } from "../../../utils/config";

export const StyledModal = styled(Modal)`
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const PopupContainer = styled.div`
  position: relative;
  background-color: white;
  border-radius: 8px;
  box-shadow: 0 4px 30px rgba(0, 0, 0, 0.1);
  padding: 32px 16px;
  width: 90vw;
  max-width: 500px;
  text-align: center;
  display: flex;
  align-items: center;
  gap: 8px;
  flex-direction: column;
`;

export const CircularImage = styled.div`
  width: 120px;
  height: 120px;
  border-radius: 50%;
  background-image: url(${ASSETS.Wheely});
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  margin: 0 auto;
  
  position: relative;
  overflow: hidden;
`;

export const BenefitsSection = styled.div`
  width: 100%;
  border-radius: 8px;
  margin-top: 16px;
  text-align: left;
`;

export const BenefitsList = styled.ul`
  padding-left: 0px;
  list-style: none;

  li {
    display: flex;
    align-items: baseline;
    gap: 8px;
    margin-bottom: 4px;
    color: #333333;

    &:before {
      content: "•";
      font-weight: bold;
      font-size: 18px;
      flex-shrink: 0;
    }
  }
`;

export const EmailInput = styled(TextField)`
  width: 100%;

  & .MuiOutlinedInput-root {
    border-radius: 8px;
    height: 45px;

    & fieldset {
      border-color: ${(props) => (props.error ? "#FF3933" : "#dfe2e6")};
      border-width: 1px;
    }

    &:hover fieldset {
      border-color: ${(props) => (props.error ? "#FF3933" : "#dfe2e6")};
    }

    &.Mui-focused fieldset {
      border-color: ${(props) => (props.error ? "#FF3933" : "#9b5af8")};
    }
  }

  & .MuiOutlinedInput-input {
    padding: 12px;
    font-family: "DM Sans", sans-serif;
    font-size: 14px;

    &::placeholder {
      color: #999999;
      opacity: 1;
    }
  }
`;

export const ErrorText = styled(Typography)`
  color: #ff3933;
  font-size: 15px;
  text-align: left;
  margin-top: 4px;
  font-family: "DM Sans", sans-serif;
`;

export const GetAppButton = styled.button`
  background-color: #181819;
  color: white;
  border: none;
  border-radius: 4px;
  padding: 12px 24px;
  font-family: "DM Sans", sans-serif;
  font-weight: 500;
  font-size: 14px;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  cursor: pointer;
  transition: background-color 0.2s ease;

  &:hover {
    background-color: #1F1F1F;
  }

  &:disabled {
    background-color: #9CA3AF;
    cursor: not-allowed;
  }
`;

export const LoginButton = styled.button`
  background-color: #9b5af8;
  color: white;
  border: none;
  border-radius: 4px;
  padding: 12px 24px;
  font-family: "DM Sans", sans-serif;
  font-weight: 500;
  font-size: 14px;
  flex: 1;
  cursor: pointer;
  transition: background-color 0.2s ease;

  &:hover {
    background-color: #7F47D8;
  }
`;

